/**
 * Mobile block-video: nur für direkte Videodateien (MP4/WebM) — Inline-<video> nach Klick.
 * YouTube/Vimeo: reines iframe im Markup, kein JS nötig.
 */
function buildInlinePlayer(url) {
	const trimmed = (url || '').trim();
	if (!trimmed) {
		return null;
	}

	const pathForExt = (trimmed.split('?')[0] || trimmed).trim();
	if (!/\.(mp4|webm|ogg)$/i.test(pathForExt)) {
		return null;
	}

	const video = document.createElement('video');
	video.setAttribute('controls', '');
	video.setAttribute('playsinline', '');
	video.setAttribute('webkit-playsinline', '');
	video.setAttribute('autoplay', '');
	video.className = 'w-full h-auto';
	video.src = trimmed;
	return video;
}

$(document).ready(function () {
	$(document).on('click', '.js-block-video-inline-trigger', function (e) {
		e.preventDefault();
		const $root = $(this).closest('.js-block-video-inline');
		const url = $root.attr('data-video-url');
		const $preview = $root.find('.js-block-video-preview');
		const $host = $root.find('.js-block-video-inline-host');

		if (!url || !$host.length) {
			return;
		}

		const player = buildInlinePlayer(String(url));
		if (!player) {
			return;
		}

		const hostEl = $host.empty().get(0);
		$preview.addClass('hidden');
		$host.removeClass('hidden').attr('aria-hidden', 'false');
		hostEl.appendChild(player);

		if (typeof player.play === 'function') {
			const playAttempt = player.play();
			if (playAttempt !== undefined && typeof playAttempt.catch === 'function') {
				playAttempt.catch(function () {});
			}
		}
	});
});
